import { type SessionAttendanceSummary } from '../../components/attendance/types';
import { type ClassStudent } from '../types';

interface SessionAttendanceObject {
    [key: string]: SessionAttendanceSummary
}

interface MakeClassAttendanceProps {
    sessionAttendanceObject: SessionAttendanceObject;
    students: ClassStudent[];
}

export const makeClassAttendance = ({ sessionAttendanceObject }: MakeClassAttendanceProps): SessionAttendanceSummary[] => Object.keys(sessionAttendanceObject).map((sessionId) => {
    const { students } = sessionAttendanceObject[sessionId];

    return ({
        session_id: sessionId,
        students
    });
});
